import React from "react";
import { Button, Card, Col} from "react-bootstrap";

const WorkCard = ({ post }) => {
    return (
        <Col lg={4} md={6} className="mb-5">
        <Card className="text-left">
          <Card.Img variant="top" src={post.img} />
          <Card.Body>
            <Card.Title>{post.title}</Card.Title>
            <Card.Text>{post.summary}</Card.Text>
            <Button variant="info" href={`/works/${post.id}`}>
              作品ページを見る
            </Button>
          </Card.Body>
        </Card>
      </Col>
    );
};

export default WorkCard;
